import React from "react";
import { useCartContext } from "../../Context/CartContext.jsx";
import CartProduct from "./CartProduct.jsx";

export const CartContainerDesktop = () => {
  const { products, subtotal } = useCartContext();
  return (
    <div className={`hidden lg:block fixed top-0 right-0 w-[150px] h-screen }`}>
      <div className="relative flex flex-col w-[150px] h-full bg-white border-l-[1px] border-slate-200 ">
        <div className="relative flex flex-col border-slate-200 w-[100%] min-h-[90px] flex justify-center items-center">
          <span className="first-letter:text-mariposa text-[22px] text-black font-bold  font-Roboto ">
            Mariposa
          </span>
          <span className="font-RobotoSlab font-[600] italic text-[20px]">
            Restaurant
          </span>
          <div className="z-[151] absolute top-[40%] -left-[8px] border-transparent border-r-[10px] border-[10px] border-r-slate-200 border-left-0"></div>
        </div>
        <div className="flex flex-col w-[100%] h-[90px] border-b-[1px] border-slate-200 justify-evenly">
          <div className="text-[16px] font-Roboto font-[400] flex justify-center">
            {products.length} Productos
          </div>
          <div className="leading-[16px] text-[18px] text-mariposa font-Roboto font-[500] flex justify-center flex-wrap">
            <span className="text-black mr-2">Subtotal: </span> ${subtotal}
          </div>
        </div>
        <div className="overflow-y-auto flex flex-col w-[150px] h-full bg-white ">
          {products.map((product, index) => (
            <CartProduct product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};
